import { FunctionComponent, useEffect } from 'react';
import { useMarkSuccess } from '@justgiving/experiments';

interface MarkSuccessProps {
  slug: string;
  successType: string;
  keyValues?: Record<string, string>;
}

// B2C_052 - b2c_interstitial_option_copy_change
// Can be removed when experiment has ended
export const MarkSuccess: FunctionComponent<MarkSuccessProps> = ({
  slug,
  successType,
  keyValues,
}) => {
  const markSuccess = useMarkSuccess(slug, successType, keyValues);

  useEffect(
    () => {
      markSuccess();
    },
    [markSuccess]
  );

  return null;
};



// WEBPACK FOOTER //
// ./src/components/MarkSuccess/MarkSuccess.tsx